import { View, Text } from "@react-pdf/renderer";
import { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";
import { ObstacleInput, UnitTypes, Units } from "../../types/sharedTypes";
import { unitFormatter } from "../../utils/units";

const PdfObstacle: FunctionComponent<{
  obstacle: ObstacleInput;
  obstacleNumber: number | null;
  unit: Units;
}> = ({ obstacle, obstacleNumber, unit }) => {
  const { t } = useTranslation();

  return (
    <View style={{ flexDirection: "row" }}>
      <View style={{ width: 80 }}>
        <Text style={{ fontSize: 10 }}>
          {t("components.settings.obstacleLabel")}
          {obstacleNumber ? ` ${obstacleNumber}` : ""}
        </Text>
      </View>
      <View style={{ flexGrow: 1 }}>
        <View style={{ position: "relative", height: 15 }}>
          <Text style={{ fontSize: 10 }}>
            {t("components.obstacleFormInput.distance")}
          </Text>
          <View
            style={{
              position: "absolute",
              bottom: 0,
              top: 0,
              left: 60,
              right: 0,
              border: "1px solid #e8e8e8",
            }}
          >
            <View style={{ left: 4, top: 1 }}>
              <Text style={{ fontSize: 10 }}>
                {unitFormatter(obstacle.distance, UnitTypes.Meter, unit)}{" "}
                {unit === Units.Metric ? t("units.meter") : t("units.foot")}
              </Text>
            </View>
          </View>
        </View>
        <View style={{ position: "relative", height: 15, marginTop: 5 }}>
          <Text style={{ fontSize: 10 }}>
            {t("components.obstacleFormInput.depth")}
          </Text>
          <View
            style={{
              position: "absolute",
              bottom: 0,
              top: 0,
              left: 60,
              right: 0,
              border: "1px solid #e8e8e8",
            }}
          >
            <View style={{ left: 4, top: 1 }}>
              <Text style={{ fontSize: 10 }}>
                {unitFormatter(obstacle.depth, UnitTypes.Meter, unit)}{" "}
                {unit === Units.Metric ? t("units.meter") : t("units.foot")}
              </Text>
            </View>
          </View>
        </View>
        <View style={{ position: "relative", height: 15, marginTop: 5 }}>
          <Text style={{ fontSize: 10 }}>
            {t("components.obstacleFormInput.height")}
          </Text>
          <View
            style={{
              position: "absolute",
              bottom: 0,
              top: 0,
              left: 60,
              right: 0,
              border: "1px solid #e8e8e8",
            }}
          >
            <View style={{ left: 4, top: 1 }}>
              <Text style={{ fontSize: 10 }}>
                {unitFormatter(obstacle.height, UnitTypes.Meter, unit)}{" "}
                {unit === Units.Metric ? t("units.meter") : t("units.foot")}
              </Text>
            </View>
          </View>
        </View>
      </View>
    </View>
  );
};

export default PdfObstacle;
